
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useBetting } from '../../../../../context/BettingContext';
import { useHistory } from 'react-router-dom';

// Styled Components
const Container = styled.div`
  width: 100%;
  background: #000000;
  font-family: 'Montserrat', sans-serif !important;
  display: flex;
  flex-direction: column;
  height: 100vh;            /* fill the viewport */

  /* Force all descendants to use Montserrat */
  *, *::before, *::after {
    font-family: 'Montserrat', sans-serif !important;
  }
`;

const Header = styled.div`
  background: rgb(50, 55, 56);
  color: #FF5C5C;
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif !important;
`;

const Content = styled.div`
  background: #000000;
  flex: 1;                  /* fill remaining space below header */
  overflow-y: auto;         /* enable vertical scroll */
  -webkit-overflow-scrolling: touch;

  /* custom scrollbar */
  &::-webkit-scrollbar { width: 8px; }
  &::-webkit-scrollbar-track { background: rgb(50, 55, 56); }
  &::-webkit-scrollbar-thumb {
    background: #FF5C5C;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgb(220, 136, 6);
  }
`;

const Match = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;
  border-bottom: 1px solid rgb(50, 55, 56);
  background: #000000;
  cursor: pointer;
`;

const MatchInfo = styled.div` flex: 1; `;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LiveDot = styled.span`
  display: inline-block;
  width: 8px; height: 8px;
  margin-right: 8px;
  background-color: #2ecc71;
  border-radius: 50%;
  animation: blink 1s ease-in-out infinite;
  @keyframes blink {
    0%,100% { opacity: 0; }
    50% { opacity: 1; }
  }
`;

const NOLiveDot = styled.span`
  display: inline-block;
  width: 8px; height: 8px;
  margin-right: 8px;
  background-color: #cccccc;
  border-radius: 50%;
`;

const MatchTitle = styled.div`
  color: #ffffff;
  font-weight: bold;
  font-size: 11px;
  font-family: 'Montserrat', sans-serif !important;
`;

const Status = styled.span`
  color: #FF5C5C;
  font-size: 12px;
  margin-left: 14px;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif !important;
`;

const NoStatus = styled.span`
  color: #cccccc;
  font-size: 10px;
  margin-left: 14px;
  font-family: 'Montserrat', sans-serif !important;
`;

const IconGroup = styled.div`
  display: flex;
  gap: 4px;
  margin-left: 8px;
`;

const PTE = styled.div`
  color: #ffffff;
  font-size: 12px;
  margin-right: 10px;
  font-family: 'Montserrat', sans-serif !important;
`;

const SportsScheduleToday = () => {
  const [matches, setMatches] = useState([]);
  const { addBet } = useBetting();      // if you’re not placing bets here, it’s safe to remove
  const history = useHistory();

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(
          'https://api.ibitplay.com/sports/matches-by-date/today',
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        const data = await res.json();

        // flatten all sports' markets into one array
        const allMarkets = data.flatMap((sport) => sport.markets || []);

        // map into your UI shape
        const mapped = allMarkets.map((m) => {
          const utcDate = new Date(m.marketStartTime);
          const istTime = new Intl.DateTimeFormat('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          }).format(utcDate);

          const team1 = m.runners[0]?.runnerName || '';
          const team2 = m.runners[1]?.runnerName || '';

          // sum of matched volumes, convert to millions
          const pteSum = m.runners.reduce(
            (sum, r) => sum + (r.totalMatched || 0),
            0
          );
          const pteLabel = `PTE${(pteSum / 1e6).toFixed(1)}M`;

          return {
            id: m.marketId,
            team1,
            team2,
            status: m.inplay ? 'In-Play' : istTime,
            isLive: m.inplay,
            pte: pteLabel,
            isSuspended: m.stopBet
          };
        });

        setMatches(mapped);
      } catch (err) {
        console.error('Failed to load today’s matches', err);
      }
    };

    fetchMatches();
  }, []);

  const handleMatchClick = (match) => {
    history.push({
      pathname: `/sports/markets/${match.id}`,
      state: { matchData: match }
    });
  };

  return (
    <Container>
      <Header>Today</Header>
      <Content>
        {matches.map((match, idx) => (
          <Match key={idx} onClick={() => handleMatchClick(match)}>
            <MatchInfo>
              <TitleContainer>
                {match.isLive ? <LiveDot /> : <NOLiveDot />}
                <MatchTitle>{`${match.team1} v ${match.team2}`}</MatchTitle>
              </TitleContainer>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {match.isLive ? (
                  <Status>In-Play</Status>
                ) : (
                  <NoStatus>{match.status}</NoStatus>
                )}
                <PTE>{match.pte}</PTE>
                <IconGroup>
                  <img
                    src="/assets/images/sports/cricket.png"
                    alt="sport"
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    src="/assets/images/sports/livestream.png"
                    alt="live"
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain'
                    }}
                  />
                  <img
                    src="/assets/images/sports/watch.png"
                    alt="watch"
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain'
                    }}
                  />
                </IconGroup>
              </div>
            </MatchInfo>
          </Match>
        ))}
      </Content>
    </Container>
  );
};

export default SportsScheduleToday;
